import { htcmdService } from 'js/services/htcmd.service';
import { useAuthSelector, useUserSelector } from 'js/store/hooks';
import { pick } from 'ramda';
import { useEffect, useState } from 'react';
import { usePrevious } from 'js/hooks/usePrevious';

export const useNativeLogoutTrigger = () => {
    const {
        isLogoutManual,
        isLogoutInProcess,
        isLoginInProcess
    } = useAuthSelector(pick(['isLogoutManual', 'isLogoutInProcess', 'isLoginInProcess']));
    const { isLoggedIn } = useUserSelector(pick(['isLoggedIn']));
    const prevIsLogoutInProcess = usePrevious(isLogoutInProcess);
    const prevIsLoginInProcess = usePrevious(isLoginInProcess);
    const [isTerminated, setIsTerminated] = useState(true);

    useEffect(() => {
        if (!htcmdService.isEnabled && !htcmdService.isWrapperEnabled) {
            // don't do in web
            return;
        }

        if (!prevIsLogoutInProcess && isLogoutInProcess) {
            // only happens after logout has finished
            setIsTerminated(true);
            htcmdService.logout(isLogoutManual ? 'manual' : 'automatic');
        }
    }, [
        isLogoutManual,
        isLogoutInProcess,
        prevIsLogoutInProcess
    ]);

    useEffect(() => {
        if (!htcmdService.isEnabled && !htcmdService.isWrapperEnabled) {
            // don't do in web
            return;
        }

        if (prevIsLoginInProcess && !isLoginInProcess && isLoggedIn) {
            // only happens after login attempt has finished with success
            setIsTerminated(false);
        }
    }, [
        isLoginInProcess,
        prevIsLoginInProcess,
        isLoggedIn
    ]);

    useEffect(() => {
        if (!htcmdService.isEnabled && !htcmdService.isWrapperEnabled) {
            // don't do in web
            return;
        }

        if (prevIsLoginInProcess && !isLoginInProcess && !isTerminated) {
            // only happens after login was attempted, but failed
            htcmdService.logout('terminated');
            setIsTerminated(true);
        }
    }, [
        isTerminated,
        isLoginInProcess,
        prevIsLoginInProcess
    ]);
};
